import Table from 'react-bootstrap/Table';
import { useTable, useSortBy } from 'react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStatusColor } from './GetStatusColor';
import InfoOverlay from '../../../components/InfoOverlay';
import BiddingsBtnGroup from './BiddingsBtnGroup';

function BiddingsTable({
  vehicles,
  competitionId,
  setShowChangeStatusError,
  competitionStatus,
  setVehicles,
}) {
  const data = useMemo(() => vehicles, [vehicles]);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: 'Tävlingsnummer',
        accessor: 'racingNumbers', // accessor is the "key" in the data
        className: 'p-3',
        style: { width: '15%' },
        Cell: ({ cell: { value } }) => (
          <div className="d-flex gap-1">
            {value?.map((rn, index) => (
              <span key={index} className="bg-secondary-black text-white p-1">
                {rn}
              </span>
            ))}
          </div>
        ),
      },
      {
        Header: 'Antal anbud',
        accessor: 'numberOfBids',
        className: 'p-3',
        style: { width: '13%' },
        Cell: ({ cell: { value } }) => (
          <span className="bg-light px-1">{value}</span>
        ),
      },
      {
        Header: 'Status',
        accessor: 'translatedBidStatus',
        className: 'p-3',
        style: { width: '12%' },
        Cell: (props) => (
          <span
            className={getStatusColor(props?.row?.original?.bidStatus) + ' p-1'}
          >
            {props?.row?.original?.translatedBidStatus}
          </span>
        ),
      },
      {
        Header: 'Vinnare',
        accessor: 'bidWinner',
        className: 'p-3',
        style: { width: '25%' },
        Cell: (props) => (
          <div className="d-flex gap-1">
            {props.row.original.bidWinner ? (
              <InfoOverlay
                name={props?.row?.original?.bidWinner}
                info={props?.row?.original?.bidWinnerDetails}
                winnerInfo={true}
              />
            ) : (
              <></>
            )}
          </div>
        ),
      },
      {
        Header: '',
        accessor: 'vehicleId',
        className: 'p-3',
        Cell: (props) => (
          <BiddingsBtnGroup
            table
            competitionStatus={competitionStatus}
            competitionId={competitionId}
            setShowChangeStatusError={setShowChangeStatusError}
            vehicle={props?.row?.original}
            setVehicles={setVehicles}
          />
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <Table
      {...getTableProps()}
      style={{
        borderCollapse: 'separate',
        borderSpacing: '0 0.5rem',
        width: '100%',
      }}
      className="table-borderless"
      hover
    >
      <thead className="bg-divider">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className="bg-white"
              style={{ borderStyle: 'none' }}
              role="button"
              onClick={() => {
                const competitionId = row?.original?.id;

                if (competitionId) {
                  navigate(`./${competitionId}/details`);
                }
              }}
            >
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className={cell.column.className}
                    style={cell.column.style}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default BiddingsTable;
